export default __webpack_public_path__ + "static/media/integrity-icon.91178d15.png";